<template>
  <v-card>
    <v-card-title class="headline">
      <v-icon>check</v-icon>
      Anular Movilidad
      <v-spacer />
      <v-btn icon @click="close()">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex md12>
            <strong>Tipo de movilidad:</strong> {{ movilidad.tipo_movimiento }}
          </v-flex>
          <v-flex md12>
            <strong>Servidor público:</strong>
            {{ movilidad.funcionario.nombre }}
          </v-flex>
          <v-flex md6> <strong>Item:</strong> {{ movilidad.nro_item }} </v-flex>
          <v-flex md6>
            <strong>Fecha desde:</strong> {{ movilidad.fecha_desde }}
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <!-- <v-btn
      color="success"
      :loading="loading"
      @click="aprobarRechazar(1)"
    >
      <v-icon>check</v-icon> Aprobar
    </v-btn> -->
      <v-btn color="error" :loading="loading" @click="aprobarRechazar(0)">
        <v-icon>clear</v-icon> Anular
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: ["movilidad"],
  data() {
    return {
      loading: false
    };
  },
  methods: {
    close() {
      this.$bus.$emit("closeDialogAprobar");
    },
    async aprobarRechazar(tipo) {
      let resps = [];
      let correcto = true;
      try {
        this.loading = true;
        let user = this.$storage.get("user");
        let res = await this.$service.graphql({
          query: `
            query{
              runQuery(consulta: "SELECT movilidad.fn_elimina_movilidad(${this.movilidad.funcionario.id_movilidad}, ${user.id})"){
                respuesta
              }
            }
          `
        });

        res = res.runQuery.respuesta[0].fn_elimina_movilidad;
        resps = res.split("|");
        correcto = resps[0];
        console.log(correcto);
        if (correcto === "1") {
          this.$message.success();
        } else {
          this.$message.error(resps);
        }
        this.close();
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/movilidad/components/AnularItem.vue